import { forwardRef, type Ref, type SVGProps } from "react";
const IconHammerFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28.38 6a5 5 0 0 0-4-2h-.58A3 3 0 0 0 21 2h-9a3 3 0 0 0-3 3H7a2 2 0 0 0-4 0v6a2 2 0 0 0 4 0h2a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-1h.67l.8.26a2.5 2.5 0 0 0 .85.14A2.69 2.69 0 0 0 29 8.16 2.8 2.8 0 0 0 28.38 6M12 25.35v.16a4.4 4.4 0 0 0 2.54 4.07A4.53 4.53 0 0 0 21 25.5v-.15L20.12 14h-7.24ZM16.5 23a2 2 0 1 1-2 2 2 2 0 0 1 2-2" />
  </svg>
);
const ForwardRef = forwardRef(IconHammerFilledSVG);
ForwardRef.displayName = "IconHammerFilled";
export { ForwardRef as IconHammerFilled };
